<div ohpInstrumentPageView="Home_PageView">
    <ohp-app-tiles-section *ngIf="showTilesSection"></ohp-app-tiles-section>
    <div role="main">
        <div class="left-nav-empty-content-state__container" *ngIf="showEmptyNavState">
            <img [src]="leftNavEmptyImage" class="left-nav-empty-content-state__image">
            <div class="left-nav-empty-content-state__text">{{leftNavEmptyStateString}}</div>
            <div class="left-nav-empty-content-state__subtitle ms-fcl-tp" [innerHTML]="leftNavEmptyStateSubtitle"></div>
        </div>
        <ohp-documents-component [firstSection]="!showTilesSection && !bottomTrayEnabled" [headless]="true" [isSuggestedActions]="showSuggestedActions"></ohp-documents-component>
        <ng-container *ngIf="showPlaces" ohpLazyView ngModulePath="places#PlacesModule"></ng-container>
        <ng-container *ngIf="showCalendar" ohpLazyView ngModulePath="calendar#CalendarModule"></ng-container>
    </div>
</div>
